import React from 'react';
import ColorListGroup from './ColorListGroup';
import PropTypes from 'prop-types';

/**
 * 12 = Grupa 1 - Folia
 * 13 = Grupa 2 - Lacobel, szkło
 * 15 = Grupa 3 - Laminat
 * 14 = Grupa 4 - Ramiak
 *
 * ? Musimy tutaj na sztywno wpisać ID grup, ponieważ JavaScript automatycznie sortuje objekty po kluczu.
 * ? Powodowało to, że grupa 4 była przed grupą 3
 */

const COLOR_LIST_FIXED_ORDER_IDS = ['12', '13', '15', '14'];

const ColorListBox = props => {
  const { title, colorsList, changeMaterial, groupList, frontColor } = props;

  return (
    <div className="color-list">
      <p className="color-list__title">{title}</p>
      {COLOR_LIST_FIXED_ORDER_IDS.map(vidx => {
        let value = groupList[vidx];
        let colorsListGroup = colorsList.filter(item => {
          return item.types.hasOwnProperty(vidx);
        });
        if (colorsListGroup.length !== 0) {
          return (
            <ColorListGroup
              key={vidx}
              title={colorsListGroup.length === 0 ? '' : value}
              colorsList={colorsListGroup}
              changeMaterial={changeMaterial}
              frontColor={frontColor}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

ColorListBox.propTypes = {
  title: PropTypes.string,
  colorsList: PropTypes.array,
  groupList: PropTypes.object,
  frontColor: PropTypes.string,
};

export default ColorListBox;
